import React, {useState} from 'react';
import Column from "./Column";
import {Field} from "../../Types";
import {getColumnValue} from "../functions";
import styled from "styled-components";
import {LoaderContainer} from "./Table";
import Loader from "../Loader";
import {useAppDispatch, useAppSelector} from "../../hooks";
import DeleteTableRecordButton from "./tableActions/DeleteTableRecordButton";
import RawEditTableRecordModal from "./tableActions/edit/RawEditTableRecordModal";
import RawAddTableRecordModal from "./tableActions/edit/RawAddTableRecordModal";
import {setTableRowOpen} from "../../features/tableSlice";

function Row({record, schema, cols, pkField, tableName, isAdmin, isSideHeaderReady}: {
    record: any,
    schema: Field[],
    cols: number,
    pkField: string,
    tableName: string,
    isAdmin: boolean,
    isSideHeaderReady: boolean
}) {

    let isFrozen = useAppSelector(state => state.tables.tableInfo[tableName].frozen[tableName + record[pkField]]);
    let isOpen = useAppSelector(state => state.tables.tableInfo[tableName].openRows[record[pkField]]);

    const dispatch = useAppDispatch();


    //todo ACTION select edit/view, approve image etc.
    return <>
        <tr onClick={() => dispatch(setTableRowOpen({table: tableName, pk: String(record[pkField]), open: !isOpen}))}
            style={{
                backgroundColor: isOpen ? 'color-mix(in srgb, var(--table-row-odd-bg-color), black 30%)' : 'var(--table-row-odd-bg-color)'
            }}>
            {schema.map(field => {
                if (!field.inline)
                    return null
                return <td key={field.key}>
                    {getColumnValue(record[field.key], field, true, record)}
                </td>
            })}
        </tr>
        {isOpen &&
            <tr>
                <td colSpan={1}/>
                <td className={'viewRow'} colSpan={cols - 1}>
                    <ViewCell $isFrozen={isFrozen}>
                        <ViewTable className={'edit-table'} $isSideHeaderReady={!!isSideHeaderReady}>
                            {/*<thead>*/}
                            {/*<tr style={{background: 'var(--table-header-bg-color)'}}>*/}
                            {/*    <th align={"center"} colSpan={cols}>Перегляд/Редагування</th>*/}
                            {/*</tr>*/}
                            {/*</thead>*/}
                            <tbody>
                            {schema.map(field => {
                                if (field.detailed || !field.inline) {
                                    return <Column value={record[field.key]} schema={field} cols={cols} record={record}
                                                   key={field.key} pk={record[pkField]}/>
                                } else {
                                    return null
                                }
                            })}
                            </tbody>
                        </ViewTable>
                        {isAdmin && <Actions>
                            <ActionsHeader>Доступні дії</ActionsHeader>
                            <hr/>
                            {isAdmin && <RawEditTableRecordModal pkValue={record[pkField]} tableKey={tableName}/>}
                            {isAdmin && <RawAddTableRecordModal pkValue={record[pkField]} tableKey={tableName}/>}
                            {isAdmin && <DeleteTableRecordButton pkValue={record[pkField]}/>}
                        </Actions>}
                        {isFrozen && <LoaderContainer>
                            <Loader show={false}/>
                        </LoaderContainer>}
                    </ViewCell>
                    <HR/>
                </td>
            </tr>
        }
    </>;
}

export default Row;

const HR = styled.hr`
    height: 4px;
    background: var(--table-action-color);
    margin: .4rem 0 0;
`

const Actions = styled.div`
    min-width: 250px;
    flex-shrink: 0;
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-flow: column;
    gap: .5rem;
    //max-width: 400px;

    //border: 2px solid var(--table-border-color);
    //border-radius: .2rem;
    padding: .2rem;

    border: 4px solid var(--table-border-color);

    & hr {
        height: 4px;
        width: 100%;
        margin: 0;
        background: var(--table-action-color);
    }

`

const ActionsHeader = styled.div`
    align-self: center;

`

const ViewCell = styled.div<any>`
    display: inline-flex;
    justify-content: left;
    flex-wrap: wrap;
    gap: .5rem;
    width: 100%;
    position: ${props => props.$isFrozen ? 'relative' : 'unset'};
`

const ViewTable = styled.table<{ $isSideHeaderReady: boolean }>`
    max-width: 100%; // Default for smaller screens
    flex-shrink: 0;
    @media (width > 1700px) {
        max-width: ${props => props.$isSideHeaderReady ? '1100px' : '1300px'};
    }
    @media (width > 1300px) and  (width <= 1500px) {
        max-width: ${props => props.$isSideHeaderReady ? '1200px' : '1000px'};
    }
    @media (width >= 1500px) and  (width < 1700px) {
        max-width: ${props => props.$isSideHeaderReady ? '1300px' : '1200px'};
    }
`;
